(function(global){
  'use strict';

  var LOCKET_VIEW = 1024;
  var DUMMY_PHOTO_A = "\/\/babeina.com\/cdn\/shop\/t\/41\/assets\/engr_dummy_photo_a.svg?v=104433710049728076121790617571";
  var DUMMY_PHOTO_B = "\/\/babeina.com\/cdn\/shop\/t\/41\/assets\/engr_dummy_photo_b.svg?v=7589605224410429701790617571";
  var HEART_PLATE_BOX = { x: 20.1, y: 25.6, w: 59.8, h: 56.4 };
  var DEFAULT_MIN_LETTER = 7;
  var DEFAULT_LINE_HEIGHT = 1.15;
  var clipIdCounter = 0;

  var HEART_CURVES = [
    { x0: 0, y0: 318, x1: -292, y1: 62, x2: -334, y2: -186, x3: -142, y3: -268 },
    { x0: -142, y0: -268, x1: -48, y1: -312, x2: 0, y2: -228, x3: 0, y3: -148 },
    { x0: 0, y0: -148, x1: 0, y1: -228, x2: 48, y2: -312, x3: 142, y3: -268 },
    { x0: 142, y0: -268, x1: 334, y1: -186, x2: 292, y2: 62, x3: 0, y3: 318 }
  ];

  function parseViewSize(raw){
    var match = String(raw || '').match(/(\d+(?:\.\d+)?)\s*$/i);
    var parsed = match ? Number(match[1]) : NaN;
    return (Number.isFinite(parsed) && parsed > 0) ? parsed : LOCKET_VIEW;
  }

  function parsePathPoints(raw){
    if (!raw) return heartTemplatePoints();
    if (Array.isArray(raw)) {
      var pts = raw.map(function(pt){
        return { x: Number(pt.x), y: Number(pt.y) };
      }).filter(function(pt){ return Number.isFinite(pt.x) && Number.isFinite(pt.y); });
      return pts.length >= 3 ? pts : heartTemplatePoints();
    }
    try {
      var parsed = JSON.parse(String(raw));
      return Array.isArray(parsed) ? parsePathPoints(parsed) : heartTemplatePoints();
    } catch (_) {
      return heartTemplatePoints();
    }
  }

  function clampLocketMaxLines(value, fallback){
    fallback = fallback == null ? 2 : fallback;
    var n = Math.round(Number(value));
    if (!Number.isFinite(n)) return fallback;
    if (n <= 1) return 1;
    if (n >= 5) return 5;
    return n;
  }

  function parsePlateShape(raw){
    var shape = String(raw || '').trim().toLowerCase();
    if (shape === 'oval' || shape === 'rect' || shape === 'heart') return shape;
    return 'heart';
  }

  function cubicPoint(curve, t){
    var mt = 1 - t;
    var a = mt * mt * mt;
    var b = 3 * mt * mt * t;
    var c = 3 * mt * t * t;
    var d = t * t * t;
    return {
      x: a * curve.x0 + b * curve.x1 + c * curve.x2 + d * curve.x3,
      y: a * curve.y0 + b * curve.y1 + c * curve.y2 + d * curve.y3
    };
  }

  var HEART_BANDS = (function(){
    var points = [];
    HEART_CURVES.forEach(function(curve){
      for (var i = 0; i <= 64; i += 1) {
        points.push(cubicPoint(curve, i / 64));
      }
    });
    var ys = points.map(function(pt){ return pt.y; });
    var xs = points.map(function(pt){ return pt.x; });
    var minY = Math.min.apply(null, ys);
    var maxY = Math.max.apply(null, ys);
    var minX = Math.min.apply(null, xs);
    var maxX = Math.max.apply(null, xs);
    var count = 48;
    var bands = Array.from({ length: count }, function(){
      return { minX: Infinity, maxX: -Infinity };
    });
    points.forEach(function(point){
      var index = Math.min(count - 1, Math.floor(((point.y - minY) / (maxY - minY)) * count));
      var band = bands[index];
      band.minX = Math.min(band.minX, point.x);
      band.maxX = Math.max(band.maxX, point.x);
    });
    for (var i = 0; i < count; i += 1) {
      if (!Number.isFinite(bands[i].minX)) {
        var prev = bands[i - 1] || bands[i + 1];
        bands[i] = { minX: prev.minX, maxX: prev.maxX };
      }
    }
    return { minX: minX, maxX: maxX, minY: minY, maxY: maxY, bands: bands };
  })();

  function normalizeText(text){
    return String(text || '').replace(/\s+/g, ' ').trim();
  }

  function roundPath(value){
    return Math.round(value * 10) / 10;
  }

  function heartTemplatePoints(count){
    count = count || 24;
    var perCurve = Math.max(4, Math.ceil(count / HEART_CURVES.length));
    var points = [];
    HEART_CURVES.forEach(function(curve){
      for (var i = 0; i < perCurve; i += 1) {
        var point = cubicPoint(curve, i / perCurve);
        points.push({
          x: 512 + point.x * 0.918,
          y: 548 + point.y * 0.918
        });
      }
    });
    return points;
  }

  function widestInteriorSpanAtY(points, y){
    var crossings = [];
    var n = points.length;
    for (var i = 0; i < n; i += 1) {
      var a = points[i];
      var b = points[(i + 1) % n];
      if (a.y === b.y) continue;
      if (a.y > y === b.y > y) continue;
      var t = (y - a.y) / (b.y - a.y);
      if (t < 0 || t > 1) continue;
      crossings.push(a.x + (b.x - a.x) * t);
    }
    if (crossings.length < 2) return null;
    crossings.sort(function(a, b){ return a - b; });
    var best = null;
    var bestSpan = 0;
    for (var j = 0; j + 1 < crossings.length; j += 2) {
      var left = crossings[j];
      var right = crossings[j + 1];
      var span = right - left;
      if (span > bestSpan) {
        bestSpan = span;
        best = { minX: left, maxX: right };
      }
    }
    return best;
  }

  function sampleClosedPath(points, bandCount){
    bandCount = bandCount || 48;
    if (!points || points.length < 3) return null;
    var ys = points.map(function(pt){ return pt.y; });
    var xs = points.map(function(pt){ return pt.x; });
    var minY = Math.min.apply(null, ys);
    var maxY = Math.max.apply(null, ys);
    var minX = Math.min.apply(null, xs);
    var maxX = Math.max.apply(null, xs);
    if (maxY - minY < 1 || maxX - minX < 1) return null;
    var bands = [];
    for (var i = 0; i < bandCount; i += 1) {
      var y = minY + ((i + 0.5) / bandCount) * (maxY - minY);
      var span = widestInteriorSpanAtY(points, y);
      bands.push(span || { minX: Infinity, maxX: -Infinity });
    }
    for (var k = 0; k < bandCount; k += 1) {
      if (!Number.isFinite(bands[k].minX)) {
        var prev = bands[k - 1] || bands[k + 1];
        bands[k] = { minX: prev.minX, maxX: prev.maxX };
      }
    }
    return { minX: minX, maxX: maxX, minY: minY, maxY: maxY, bands: bands };
  }

  function pathBoxPercent(sample, viewSize){
    viewSize = viewSize || LOCKET_VIEW;
    return {
      x: (sample.minX / viewSize) * 100,
      y: (sample.minY / viewSize) * 100,
      w: ((sample.maxX - sample.minX) / viewSize) * 100,
      h: ((sample.maxY - sample.minY) / viewSize) * 100
    };
  }

  function widthRatioFromSample(sample, y01, inset){
    inset = inset == null ? 0.88 : inset;
    var y = Math.min(1, Math.max(0, y01));
    var index = Math.min(sample.bands.length - 1, Math.floor(y * sample.bands.length));
    var band = sample.bands[index];
    var span = (band.maxX - band.minX) / (sample.maxX - sample.minX);
    return Math.max(0.16, span * inset);
  }

  function largestAreaBandFromSample(sample, widthThreshold){
    widthThreshold = widthThreshold == null ? 0.72 : widthThreshold;
    var n = sample.bands.length;
    if (n === 0) return { top: 0.22, height: 0.48 };
    var spans = sample.bands.map(function(band){ return Math.max(0, band.maxX - band.minX); });
    var maxSpan = Math.max.apply(null, spans.concat([0]));
    if (maxSpan <= 0) return { top: 0.22, height: 0.48 };
    var wideEnough = spans.map(function(span){ return span >= maxSpan * widthThreshold; });
    var bestStart = 0;
    var bestLen = 0;
    var runStart = -1;
    for (var i = 0; i <= n; i += 1) {
      if (i < n && wideEnough[i]) {
        if (runStart < 0) runStart = i;
      } else if (runStart >= 0) {
        var len = i - runStart;
        if (len > bestLen) {
          bestLen = len;
          bestStart = runStart;
        }
        runStart = -1;
      }
    }
    if (bestLen < 3) {
      var weight = 0;
      var weightedY = 0;
      for (var j = 0; j < n; j += 1) {
        var spanVal = spans[j];
        weight += spanVal;
        weightedY += ((j + 0.5) / n) * spanVal;
      }
      var center = weight > 0 ? weightedY / weight : 0.4;
      return {
        top: Math.max(0.08, Math.min(0.5, center - 0.24)),
        height: 0.48
      };
    }
    return {
      top: bestStart / n,
      height: Math.max(0.28, bestLen / n)
    };
  }

  function stagePointsFromViewPoints(points, viewSize){
    var scale = 100 / viewSize;
    return points.map(function(pt){ return { x: pt.x * scale, y: pt.y * scale }; });
  }

  function clipPathDForWellBox(stagePoints, wellBox){
    if (!stagePoints.length) return '';
    var round = function(v){ return Math.round(v * 1000) / 1000; };
    var first = stagePoints[0];
    var toUv = function(pt){
      return {
        x: (pt.x - wellBox.left) / wellBox.width,
        y: (pt.y - wellBox.top) / wellBox.height
      };
    };
    var start = toUv(first);
    var path = 'M' + round(start.x) + ' ' + round(start.y);
    for (var i = 1; i < stagePoints.length; i += 1) {
      var uv = toUv(stagePoints[i]);
      path += ' L' + round(uv.x) + ' ' + round(uv.y);
    }
    return path + 'Z';
  }

  function plateClipPathFromPoints(points, viewSize){
    var sample = sampleClosedPath(points);
    if (!sample) return null;
    var box = pathBoxPercent(sample, viewSize);
    var wellBox = { left: box.x, top: box.y, width: box.w, height: box.h };
    var stagePoints = stagePointsFromViewPoints(points, viewSize);
    var clipPathD = clipPathDForWellBox(stagePoints, wellBox);
    if (!clipPathD) return null;
    return { box: box, clipPathD: clipPathD };
  }

  function absoluteMediaUrl(url){
    var raw = String(url || '').trim();
    if (!raw) return '';
    if (raw.indexOf('//') === 0) return 'https:' + raw;
    return raw;
  }

  function resolveFaceLayout(faceJson){
    var face = faceJson || {};
    var photoUrl = absoluteMediaUrl(
      face.photo || face.platePhotoUrl || face.platePhoto || face.plate_photo || ''
    );
    var viewSize = parseViewSize(face.viewBox || face.view_box);
    var points = [];
    if (Array.isArray(face.pathPoints) && face.pathPoints.length > 0) {
      points = parsePathPoints(face.pathPoints);
    } else if (typeof face.path_points === 'string' && face.path_points.trim()) {
      points = parsePathPoints(face.path_points);
    } else if (typeof face.pathPoints === 'string' && face.pathPoints.trim()) {
      points = parsePathPoints(face.pathPoints);
    } else {
      points = parsePathPoints(null);
    }
    var pathLayout = plateClipPathFromPoints(points, viewSize);
    var box = pathLayout ? pathLayout.box : { x: 26, y: 40, w: 48, h: 30 };
    return {
      photo: photoUrl,
      box: box,
      shape: parsePlateShape(face.shape),
      maxLines: clampLocketMaxLines(face.maxLines != null ? face.maxLines : face.max_lines),
      clipPathD: pathLayout ? pathLayout.clipPathD : undefined,
      pathPoints: pathLayout ? points : undefined,
      viewSize: pathLayout ? viewSize : undefined
    };
  }

  function plateWidthRatio(shape, y01){
    var y = Math.min(1, Math.max(0, y01));
    if (shape === 'rect') return 1;
    if (shape === 'oval') {
      var ny = (y - 0.5) * 2;
      var r = 1 - ny * ny;
      return r <= 0 ? 0.16 : Math.max(0.2, Math.sqrt(r));
    }
    var bands = HEART_BANDS.bands;
    var index = Math.min(bands.length - 1, Math.floor(y * bands.length));
    var band = bands[index];
    var span = (band.maxX - band.minX) / (HEART_BANDS.maxX - HEART_BANDS.minX);
    return Math.max(0.18, span * 0.88);
  }

  function splitWordToWidth(word, fontPx, maxWidth, measure){
    if (!word.length) return [];
    if (measure(word, fontPx) <= maxWidth) return [word];
    var chunks = [];
    var current = '';
    for (var i = 0; i < word.length; i += 1) {
      var char = word.charAt(i);
      var next = current + char;
      if (current && measure(next, fontPx) > maxWidth) {
        chunks.push(current);
        current = char;
      } else {
        current = next;
      }
    }
    if (current) chunks.push(current);
    return chunks;
  }

  function wrapPlateText(text, fontPx, maxWidth, maxLines, measure, allowWordSplit){
    var clean = normalizeText(text);
    var limit = Math.max(1, Math.floor(maxLines));
    if (!clean) return { lines: [], overflow: false };
    if (maxWidth <= 0) return { lines: [clean], overflow: true };
    var tokens = clean.split(' ');
    var pieces = [];
    for (var ti = 0; ti < tokens.length; ti += 1) {
      var token = tokens[ti];
      if (measure(token, fontPx) > maxWidth) {
        if (!allowWordSplit) return { lines: [clean], overflow: true };
        pieces.push.apply(pieces, splitWordToWidth(token, fontPx, maxWidth, measure));
      } else {
        pieces.push(token);
      }
    }
    var lines = [];
    var current = '';
    pieces.forEach(function(piece){
      var next = current ? current + ' ' + piece : piece;
      if (current && measure(next, fontPx) > maxWidth) {
        lines.push(current);
        current = piece;
      } else {
        current = next;
      }
    });
    if (current) lines.push(current);
    if (lines.length <= limit) return { lines: lines, overflow: false };
    return { lines: lines.slice(0, limit), overflow: true };
  }

  function wrapPlateTextToWidths(text, fontPx, widths, measure, allowWordSplit){
    var clean = normalizeText(text);
    if (!clean) return { lines: [], overflow: false };
    if (!widths.length) return { lines: [clean], overflow: true };
    var queue = clean.split(' ');
    var lines = [];
    var current = '';
    var lineIndex = 0;

    function flush(){
      if (current) lines.push(current);
      current = '';
      lineIndex += 1;
    }

    while (queue.length) {
      if (lineIndex >= widths.length) {
        return { lines: current ? lines.concat([current]) : lines, overflow: true };
      }
      var word = queue.shift();
      var maxWidth = Math.max(0, widths[lineIndex] || 0);
      var next = current ? current + ' ' + word : word;
      if (current && measure(next, fontPx) > maxWidth) {
        flush();
        queue.unshift(word);
        continue;
      }
      if (!current && measure(word, fontPx) > maxWidth) {
        if (!allowWordSplit) return { lines: lines.concat([word]), overflow: true };
        var chunks = splitWordToWidth(word, fontPx, maxWidth, measure);
        current = chunks[0] || '';
        for (var i = chunks.length - 1; i >= 1; i -= 1) {
          queue.unshift(chunks[i]);
        }
        if (queue.length) flush();
        continue;
      }
      current = next;
    }
    if (current) lines.push(current);
    return { lines: lines, overflow: false };
  }

  function lineWidthsForRatio(widthAtY, lineCount, fontPx, boxWidth, boxHeight, lineHeight, bandTop, bandHeight){
    var n = Math.max(1, lineCount);
    var blockRatio = (n * fontPx * lineHeight) / Math.max(1, boxHeight);
    var start = bandTop + Math.max(0, (bandHeight - blockRatio) / 2);
    return Array.from({ length: n }, function(_, index){
      var y01 = start + ((index + 0.5) * fontPx * lineHeight) / Math.max(1, boxHeight);
      return boxWidth * widthAtY(y01);
    });
  }

  function fitPlateText(input){
    var clean = normalizeText(input.text);
    var minLetter = input.minLetterHeight != null ? input.minLetterHeight : DEFAULT_MIN_LETTER;
    var lineHeight = input.lineHeight != null ? input.lineHeight : DEFAULT_LINE_HEIGHT;
    var maxLines = Math.max(1, Math.floor(input.maxLines));
    var shape = input.shape || 'rect';
    var customWidth = input.widthAtY;
    // Cap single-line height only; the line-count loop below shrinks when copy needs 2+ lines.
    var maxLetter = Math.max(
      minLetter,
      Math.min(input.maxLetterHeight, input.boxHeight / lineHeight)
    );

    if (!clean) return { lines: [], fontPx: maxLetter, fits: true };
    if (input.boxWidth <= 0 || input.boxHeight <= 0) {
      return { lines: [clean], fontPx: minLetter, fits: false };
    }

    var fontPx = maxLetter;
    var best = { lines: [clean], fontPx: minLetter, fits: false };

    while (fontPx >= minLetter - 0.01) {
      var allowWordSplit = fontPx <= minLetter + 0.01;
      if (!customWidth && shape === 'rect') {
        var wrapped = wrapPlateText(clean, fontPx, input.boxWidth, maxLines, input.measure, allowWordSplit);
        var height = wrapped.lines.length * fontPx * lineHeight;
        var fits = !wrapped.overflow && height <= input.boxHeight + 0.01;
        if (fits) return { lines: wrapped.lines, fontPx: fontPx, fits: true };
        best = { lines: wrapped.lines, fontPx: fontPx, fits: false };
      } else {
        var widthAtY = customWidth || function(y01){ return plateWidthRatio(shape, y01); };
        var textBand = input.textBand || (customWidth
          ? { top: 0.12, height: 0.76 }
          : shape === 'heart'
            ? { top: 0.3, height: 0.48 }
            : { top: 0.08, height: 0.84 });
        var bandTop = textBand.top;
        var bandHeight = textBand.height;
        var usable = input.boxHeight * Math.min(0.95, Math.max(0.35, bandHeight * 0.92));
        var fitted = null;
        for (var lines = 1; lines <= maxLines; lines += 1) {
          var widths = lineWidthsForRatio(widthAtY, lines, fontPx, input.boxWidth, input.boxHeight, lineHeight, bandTop, bandHeight);
          var wrappedShape = wrapPlateTextToWidths(clean, fontPx, widths, input.measure, allowWordSplit);
          var blockHeight = wrappedShape.lines.length * fontPx * lineHeight;
          if (!wrappedShape.overflow && wrappedShape.lines.length <= lines && blockHeight <= usable + 0.01) {
            fitted = { lines: wrappedShape.lines, fontPx: fontPx, fits: true };
            break;
          }
          best = { lines: wrappedShape.lines, fontPx: fontPx, fits: false };
        }
        if (fitted) return fitted;
      }
      fontPx = Math.round((fontPx - 0.5) * 10) / 10;
    }
    return best;
  }

  function defaultMaxLetterHeight(boxHeight, maxLines){
    var lines = Math.max(1, maxLines);
    return boxHeight / (lines * DEFAULT_LINE_HEIGHT);
  }

  function cssStack(family){
    var trimmed = String(family || '').trim();
    if (!trimmed) return 'Georgia, serif';
    if (trimmed.indexOf(',') >= 0 || trimmed.charAt(0) === '"' || trimmed.charAt(0) === "'" || trimmed.indexOf('var(') === 0) {
      return trimmed;
    }
    return '"' + trimmed + '", Georgia, serif';
  }

  function measureFactory(fontFamily){
    var ctx = null;
    return function(text, fontPx){
      if (typeof document === 'undefined') return String(text).length * fontPx * 0.55;
      if (!ctx) {
        var canvas = document.createElement('canvas');
        ctx = canvas.getContext('2d');
      }
      if (!ctx) return String(text).length * fontPx * 0.55;
      ctx.font = '400 ' + fontPx + 'px ' + cssStack(fontFamily);
      return ctx.measureText(String(text)).width;
    };
  }

  function hasCalibratedPath(face){
    return Boolean(face && face.clipPathD && face.pathPoints && face.pathPoints.length >= 3);
  }

  function occupiedFillBox(box){
    var w = Math.max(box.w, 42);
    var h = Math.max(box.h, 38);
    var x = box.x - (w - box.w) / 2;
    var y = box.y - (h - box.h) / 2;
    return {
      x: Math.max(8, Math.min(x, 92 - w)),
      y: Math.max(10, Math.min(y, 88 - h)),
      w: w,
      h: h
    };
  }

  function keyInList(list, key){
    if (!list) return false;
    if (Array.isArray(list)) return list.indexOf(key) >= 0;
    if (typeof list === 'object') return !!list[key];
    return false;
  }

  function escapeAttr(value){
    if (typeof CSS !== 'undefined' && CSS.escape) return CSS.escape(String(value));
    return String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  }

  function onSelectFace(key){
    var drawer = document.getElementById('engr-drawer');
    if (!drawer) return;
    var side = drawer.querySelector('.engr-side[data-key="' + escapeAttr(key) + '"]');
    var input = side ? side.querySelector('.engr-side-input') : null;
    if (input && !input.disabled) {
      try { input.focus({ preventScroll: true }); } catch (_) { input.focus(); }
      try { input.select(); } catch (_) {}
    }
  }

  function nextClipId(key){
    clipIdCounter += 1;
    return 'engr-plate-clip-' + String(key || 'face').replace(/\W+/g, '-') + '-' + clipIdCounter;
  }

  function dummyPhotoForKey(key){
    return /right/i.test(String(key || '')) ? DUMMY_PHOTO_B : DUMMY_PHOTO_A;
  }

  function occupiedFillSrc(face){
    return (face && face.occupiedPhoto) || dummyPhotoForKey(face && face.key);
  }

  function photoObjectPosition(face){
    if (face && face.photoObjectPosition) return String(face.photoObjectPosition);
    var key = String((face && face.key) || '').toLowerCase();
    var offsets = {
      inside_right: '48.1% 48.3%',
      inside_left: '47.1% 46.7%',
      front: '45.7% 48.5%',
      back: '44.7% 47.2%'
    };
    return offsets[key] || '47% 48%';
  }

  function createPlateCell(face, state, onSelect){
    var occupied = keyInList(state.occupiedKeys, face.key);
    var rawText = (state.textsByKey && state.textsByKey[face.key]) || '';
    var text = state.uppercase ? String(rawText).toUpperCase() : rawText;
    var calibrated = hasCalibratedPath(face);
    var fillBox = occupied ? occupiedFillBox(face.box) : face.box;
    var textBox = calibrated ? face.box : face.shape === 'heart' ? HEART_PLATE_BOX : fillBox;
    var heartFill = Boolean(occupied && face.shape === 'heart' && !calibrated);
    var pathSample = calibrated ? sampleClosedPath(face.pathPoints) : null;
    var textBand = pathSample
      ? largestAreaBandFromSample(pathSample)
      : face.shape === 'heart'
        ? { top: 0.3, height: 0.48 }
        : { top: 0.08, height: 0.84 };
    var clipId = calibrated ? nextClipId(face.key) : '';
    var measure = measureFactory(state.fontFamily || '');
    var fit = { lines: [], fontPx: 16, fits: true };
    var displayLines = [];

    var cell = document.createElement(onSelect ? 'button' : 'div');
    cell.type = onSelect ? 'button' : undefined;
    cell.className = 'engr-plate__cell';
    cell.dataset.key = face.key;
    if (onSelect) {
      cell.setAttribute('aria-label', occupied
        ? (face.label + ', photo occupies this side')
        : ('Edit ' + face.label + ' engraving'));
    }

    var stage = document.createElement('div');
    stage.className = 'engr-plate__stage';

    var photo = document.createElement('img');
    photo.className = 'engr-plate__photo';
    photo.src = face.photo || '';
    photo.style.objectPosition = photoObjectPosition(face);
    photo.alt = occupied
      ? (face.label + ' plate, photo will be placed here')
      : (face.label + ' engraving plate');

    var boxEl = null;
    var textEl = null;
    var defsSvg = null;

    function sideLabelText(){
      return String(face.label || face.key || '').trim();
    }

    function renderPlaceholder(){
      if (!textEl) {
        textEl = document.createElement('span');
      }
      textEl.className = 'engr-plate__text is-placeholder';
      textEl.style.removeProperty('font-family');
      textEl.style.removeProperty('font-size');
      textEl.style.removeProperty('text-transform');
      textEl.innerHTML = '';
      var lineEl = document.createElement('span');
      lineEl.className = 'engr-plate__line';
      lineEl.textContent = sideLabelText();
      textEl.appendChild(lineEl);
      return textEl;
    }

    function renderTextNode(lines, fontPx){
      if (!textEl) {
        textEl = document.createElement('span');
      }
      textEl.className = 'engr-plate__text';
      textEl.style.fontFamily = cssStack(state.fontFamily || '');
      textEl.style.fontSize = fontPx + 'px';
      if (state.uppercase) textEl.style.textTransform = 'uppercase';
      else textEl.style.textTransform = '';
      textEl.innerHTML = '';
      lines.forEach(function(line, index){
        var lineEl = document.createElement('span');
        lineEl.className = 'engr-plate__line';
        lineEl.textContent = state.uppercase ? String(line).toUpperCase() : line;
        textEl.appendChild(lineEl);
      });
      return textEl;
    }

    function recomputeFit(){
      if (state.skip || occupied || !boxEl) {
        fit = { lines: [], fontPx: 16, fits: true };
        displayLines = [];
        if (textEl) textEl.innerHTML = '';
        if (boxEl) boxEl.dataset.fits = 'true';
        return;
      }
      if (!String(text).trim()) {
        fit = { lines: [], fontPx: 16, fits: true };
        displayLines = [];
        boxEl.dataset.fits = 'true';
        renderPlaceholder();
        return;
      }
      var insetX = pathSample ? 8 : face.shape === 'heart' ? 6 : 8;
      var insetY = pathSample ? 6 : face.shape === 'heart' ? 4 : 6;
      var width = Math.max(0, boxEl.clientWidth - insetX);
      var height = Math.max(0, boxEl.clientHeight - insetY);
      if (width < 8 || height < 8) {
        window.requestAnimationFrame(recomputeFit);
        return;
      }
      var usableHeight = height * textBand.height * 0.92;
      var previewScale = state.previewScale;
      if (!isFinite(previewScale) || previewScale <= 0) previewScale = 1;
      fit = fitPlateText({
        text: text,
        maxLines: face.maxLines,
        boxWidth: width,
        boxHeight: height,
        maxLetterHeight: defaultMaxLetterHeight(usableHeight, 1) * previewScale,
        shape: face.shape,
        widthAtY: pathSample ? function(y01){ return widthRatioFromSample(pathSample, y01); } : undefined,
        textBand: pathSample || face.shape === 'heart' ? textBand : undefined,
        measure: measure
      });
      displayLines = state.uppercase ? fit.lines.map(function(line){ return String(line).toUpperCase(); }) : fit.lines.slice();
      boxEl.dataset.fits = fit.fits ? 'true' : 'false';
      renderTextNode(displayLines, fit.fontPx);
    }

    if (calibrated && clipId) {
      defsSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      defsSvg.setAttribute('width', '0');
      defsSvg.setAttribute('height', '0');
      defsSvg.setAttribute('aria-hidden', 'true');
      defsSvg.setAttribute('focusable', 'false');
      var defs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
      var clipPath = document.createElementNS('http://www.w3.org/2000/svg', 'clipPath');
      clipPath.setAttribute('id', clipId);
      clipPath.setAttribute('clipPathUnits', 'objectBoundingBox');
      var pathNode = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      pathNode.setAttribute('d', face.clipPathD);
      clipPath.appendChild(pathNode);
      defs.appendChild(clipPath);
      defsSvg.appendChild(defs);
    }

    if (heartFill) {
      var heartImg = document.createElement('img');
      heartImg.className = 'engr-plate__fill engr-plate__fill--heart';
      heartImg.src = occupiedFillSrc(face);
      heartImg.alt = '';
      heartImg.setAttribute('aria-hidden', 'true');
      stage.appendChild(defsSvg);
      stage.appendChild(photo);
      stage.appendChild(heartImg);
    } else if (calibrated) {
      boxEl = document.createElement('div');
      boxEl.className = 'engr-plate__box engr-plate__box--path';
      boxEl.style.left = textBox.x + '%';
      boxEl.style.top = textBox.y + '%';
      boxEl.style.width = textBox.w + '%';
      boxEl.style.height = textBox.h + '%';
      boxEl.style.clipPath = 'url(#' + clipId + ')';
      boxEl.setAttribute('aria-hidden', 'true');
      if (occupied) {
        var fillImg = document.createElement('img');
        fillImg.className = 'engr-plate__fill';
        fillImg.src = occupiedFillSrc(face);
        fillImg.alt = '';
        boxEl.appendChild(fillImg);
      } else {
        var pathClip = document.createElement('div');
        pathClip.className = 'engr-plate__path-clip';
        pathClip.style.position = 'absolute';
        pathClip.style.left = '0';
        pathClip.style.width = '100%';
        pathClip.style.top = (textBand.top * 100) + '%';
        pathClip.style.height = (textBand.height * 100) + '%';
        pathClip.appendChild(renderPlaceholder());
        boxEl.appendChild(pathClip);
      }
      stage.appendChild(defsSvg);
      stage.appendChild(photo);
      stage.appendChild(boxEl);
    } else if (face.shape === 'heart') {
      var heartStage = document.createElement('div');
      heartStage.className = 'engr-plate__heart-stage';
      heartStage.setAttribute('aria-hidden', 'true');
      var heartAlign = document.createElement('div');
      heartAlign.className = 'engr-plate__heart-align';
      boxEl = document.createElement('div');
      boxEl.className = 'engr-plate__box engr-plate__box--heart';
      boxEl.style.left = textBox.x + '%';
      boxEl.style.top = textBox.y + '%';
      boxEl.style.width = textBox.w + '%';
      boxEl.style.height = textBox.h + '%';
      boxEl.dataset.fits = 'true';
      if (occupied) {
        var occImg = document.createElement('img');
        occImg.className = 'engr-plate__fill';
        occImg.src = occupiedFillSrc(face);
        occImg.alt = '';
        boxEl.appendChild(occImg);
      } else {
        boxEl.appendChild(renderPlaceholder());
      }
      heartAlign.appendChild(boxEl);
      heartStage.appendChild(heartAlign);
      stage.appendChild(photo);
      stage.appendChild(heartStage);
    } else {
      boxEl = document.createElement('div');
      boxEl.className = 'engr-plate__box engr-plate__box--' + face.shape;
      boxEl.style.left = fillBox.x + '%';
      boxEl.style.top = fillBox.y + '%';
      boxEl.style.width = fillBox.w + '%';
      boxEl.style.height = fillBox.h + '%';
      boxEl.setAttribute('aria-hidden', 'true');
      if (occupied) {
        var fill = document.createElement('img');
        fill.className = 'engr-plate__fill';
        fill.src = occupiedFillSrc(face);
        fill.alt = '';
        boxEl.appendChild(fill);
      } else {
        boxEl.appendChild(renderPlaceholder());
      }
      stage.appendChild(photo);
      stage.appendChild(boxEl);
    }

    cell.appendChild(stage);
    if (photo.src) {
      var bleed = document.createElement('div');
      bleed.className = 'engr-plate__bleed';
      bleed.setAttribute('aria-hidden', 'true');
      var bleedImg = document.createElement('img');
      bleedImg.src = photo.src;
      bleedImg.alt = '';
      bleedImg.style.objectPosition = photo.style.objectPosition || '';
      bleed.appendChild(bleedImg);
      cell.appendChild(bleed);
    }

    var empty = !occupied && !String(text).trim();
    if (empty) cell.classList.add('is-empty');
    if (occupied) cell.classList.add('is-occupied');
    if (calibrated) cell.classList.add('has-calibrated-path');
    if (state.skip) cell.classList.add('is-skipped');

    if (onSelect) {
      cell.addEventListener('click', function(){
        onSelect(face.key);
      });
    }

    var ro = null;
    if (boxEl && typeof ResizeObserver !== 'undefined') {
      ro = new ResizeObserver(function(){ recomputeFit(); });
      ro.observe(boxEl);
    }
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function(){ recomputeFit(); }).catch(function(){});
    }
    requestAnimationFrame(function(){ recomputeFit(); });

    return {
      el: cell,
      recomputeFit: recomputeFit,
      disconnect: function(){
        if (ro) ro.disconnect();
      }
    };
  }

  function create(options){
    var root = options && options.root;
    var sideOrder = (options && options.sideOrder) || [];
    var facesByKey = (options && options.facesByKey) || {};
    var getState = options && options.getState;
    if (!root || typeof getState !== 'function') return null;

    var shell = document.createElement('div');
    shell.className = 'engr-plate';
    shell.setAttribute('aria-label', 'Engraving preview');

    var grid = document.createElement('div');
    grid.className = 'engr-plate__grid';
    shell.appendChild(grid);
    root.innerHTML = '';
    root.appendChild(shell);

    var cells = [];

    function buildFaces(state){
      return sideOrder.slice(0, 4).map(function(key){
        var layout = facesByKey[key] || {};
        var meta = layout.meta || {};
        return {
          key: key,
          label: layout.label || meta.label || key,
          photo: layout.photo || '',
          box: layout.box || { x: 26, y: 40, w: 48, h: 30 },
          shape: layout.shape || 'heart',
          maxLines: layout.maxLines != null ? layout.maxLines : 2,
          clipPathD: layout.clipPathD,
          pathPoints: layout.pathPoints,
          viewSize: layout.viewSize,
          occupiedPhoto: layout.occupiedPhoto
        };
      });
    }

    function render(){
      var state = getState() || {};
      var faces = buildFaces(state);
      var count = Math.min(4, faces.length);
      grid.dataset.count = String(count || 1);
      cells.forEach(function(cell){ cell.disconnect(); });
      cells = [];
      grid.innerHTML = '';
      if (!count) {
        shell.hidden = true;
        return;
      }
      shell.hidden = !!state.skip && false;
      shell.classList.toggle('is-skipped', !!state.skip);
      faces.forEach(function(face){
        var cell = createPlateCell(face, state, function(key){
          onSelectFace(key);
        });
        cells.push(cell);
        grid.appendChild(cell.el);
      });
    }

    render();

    return {
      update: render,
      destroy: function(){
        cells.forEach(function(cell){ cell.disconnect(); });
        cells = [];
        root.innerHTML = '';
      }
    };
  }

  global.BabeinaLocketPlatePreview = {
    LOCKET_VIEW: LOCKET_VIEW,
    HEART_PLATE_BOX: HEART_PLATE_BOX,
    resolveFaceLayout: resolveFaceLayout,
    sampleClosedPath: sampleClosedPath,
    pathBoxPercent: pathBoxPercent,
    largestAreaBandFromSample: largestAreaBandFromSample,
    widthRatioFromSample: widthRatioFromSample,
    plateWidthRatio: plateWidthRatio,
    wrapPlateText: wrapPlateText,
    wrapPlateTextToWidths: wrapPlateTextToWidths,
    fitPlateText: fitPlateText,
    defaultMaxLetterHeight: defaultMaxLetterHeight,
    create: create
  };
})(typeof window !== 'undefined' ? window : this);
